export default {"src":"/_next/static/media/houses.978d1187.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};